export default "__VITE_ASSET__BHaSZGgs__"